"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.weights = exports.variants = exports.typeWeight = exports.TypeElement = void 0;
var _index = require("../../styles/index.js");
var _typeHelpers = require("../../typeHelpers.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var variants = exports.variants = {
  bass: 'bass',
  forte: 'forte',
  brio: 'brio',
  altoBrio: 'altoBrio',
  alto: 'alto',
  canon: 'canon',
  celloCanon: 'celloCanon',
  cello: 'cello',
  ballad: 'ballad',
  balladBold: 'balladBold',
  viola: 'viola',
  violaBold: 'violaBold',
  mesto: 'mesto',
  mestoBold: 'mestoBold',
  metronome: 'metronome',
  finale: 'finale',
  finaleBold: 'finaleBold',
  minuet: 'minuet',
  minuetBold: 'minuetBold'
};
var weights = exports.weights = {
  book: 'book',
  bold: 'bold',
  black: 'black'
};
var typeWeight = exports.typeWeight = function typeWeight(weight) {
  switch (weight) {
    case 'book':
      return _index.fontWeightBook;
    case 'bold':
      return _index.fontWeightBold;
    case 'black':
      return _index.fontWeightBlack;
    default:
      return (0, _typeHelpers.assertNever)(weight);
  }
};
var variantStyles = function variantStyles(variant) {
  switch (variant) {
    case 'bass':
      return (0, _index.bass)();
    case 'forte':
      return (0, _index.forte)();
    case 'brio':
      return (0, _index.brio)();
    case 'altoBrio':
      return (0, _index.altoBrio)();
    case 'alto':
      return (0, _index.alto)();
    case 'canon':
      return (0, _index.canon)();
    case 'celloCanon':
      return (0, _index.celloCanon)();
    case 'cello':
      return (0, _index.cello)();
    case 'ballad':
      return (0, _index.ballad)();
    case 'balladBold':
      return (0, _index.balladBold)();
    case 'viola':
      return (0, _index.viola)();
    case 'violaBold':
      return (0, _index.violaBold)();
    case 'mesto':
      return (0, _index.mesto)();
    case 'mestoBold':
      return (0, _index.mestoBold)();
    case 'metronome':
      return (0, _index.metronome)();
    case 'finale':
      return (0, _index.finale)();
    case 'finaleBold':
      return (0, _index.finaleBold)();
    case 'minuet':
      return (0, _index.minuet)();
    case 'minuetBold':
      return (0, _index.minuetBold)();
    default:
      return (0, _index.viola)();
  }
};
var TypeElement = exports.TypeElement = _styledComponents["default"].span.withConfig({
  displayName: "Type__TypeElement",
  componentId: "sc-goli3j-0"
})(["", ";margin-block:0;", ";", ";", " ", ";"], (0, _index.rootStyle)(), function (props) {
  return props.$variant ? variantStyles(props.$variant) : undefined;
}, function (props) {
  return props.$paddingBottom && (0, _styledComponents.css)(["padding-block-end:", ";"], props.$paddingBottom);
}, function (props) {
  return props.$semanticColor ? (0, _styledComponents.css)(["color:", ";"], (0, _index.cssColorValue)(props.$semanticColor)) : (0, _styledComponents.css)(["color:inherit;"]);
}, function (props) {
  return props.$weight && (0, _styledComponents.css)(["font-weight:", ";"], typeWeight(props.$weight));
});